import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购入库结果单列表
    { key: 'getStockinResults', url: 'stockin-results', method: 'GET' },
    // 采购入库结果单明细
    { key: 'stockinResultsDetail', url: 'stockin-results/detail', method: 'GET' },
    // 采购入库结果单导出
    { key: 'reportstockinResults', url: 'stockin-results/report', method: 'GET', rType: 2 },
  ],
};
export default {
  ...generate(config),
};
